import { gql } from "@apollo/client";

export const GET_PRINT_RESUMEN = gql`
query GetPrintResumenIngreso($resumen: String!, $numeroRI: String!, $soloCP: Boolean!) {
    printResumenIngreso(resumen: $resumen, numeroRI: $numeroRI, soloCP: $soloCP)
}`;